<template>
  <div class="responsive">
    <TodoNav></TodoNav>
    <TodoList></TodoList>
  </div>
</template>

<script>
import TodoList from './TodoList.vue'
import TodoNav from './TodoNav.vue'

import { authRef } from '../store/db.js';
export default {
  beforeCreate(){
      authRef.onAuthStateChanged(user=>{
          if(!user) this.$router.push('/');
          else{
              this.$store.commit('userAuth', user);
          }
      })
  },
  components: {
    'TodoNav': TodoNav,
    'TodoList': TodoList,
  }
}
</script>
<style>
  body {
    text-align: center;
    background-color: #F6F6F8;
  }
  input {
    border-style: groove;
    width: 200px;
  }
  button {
    border-style: groove;
  }
  .shadow {
    box-shadow: 5px 10px 10px rgba(0, 0, 0, 0.03)
  }
</style>



// WEBPACK FOOTER //
// src/components/TodoContents.vue